import { TextInput } from "@ferrivia/ui";
import { useDateInput } from "../../components/DateInput";
import { focusWithoutPan } from "../../onboarding/focusWithoutPan";
import f from "./fieldBox.module.css";

export interface DateQuestionProps {
  labelledBy: string;
  value: string;
  onChange: (value: string) => void;
  errorText?: string;
}

export function DateQuestion({ labelledBy, value, onChange, errorText }: DateQuestionProps) {
  const { invalid, ...dateProps } = useDateInput(value, onChange);
  return (
    <TextInput
      className={f.box}
      aria-labelledby={labelledBy}
      {...dateProps}
      onMouseDown={focusWithoutPan}
      aria-invalid={invalid || Boolean(errorText)}
    />
  );
}
